import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../../theme';

const { fonts } = redesignTheme;

export const useDetailModalStyles = makeStyles(() => ({
  paper: {
    width: 'calc(100% - 64px)',
    maxWidth: 1120,
    borderRadius: 16,
    margin: 32,
    '@media (max-width: 700px)': { width: 'calc(100% - 24px)', margin: 12 },
  },
  content: {
    padding: '0 !important',
    color: '#333333',
    fontFamily: fonts.opensans,
    fontSize: 14,
    lineHeight: '22px',
    overflowX: 'hidden',
    '& h2, & h3': {
      fontFamily: fonts.gothicSemiBold,
      fontWeight: 600,
      lineHeight: 1.3,
      margin: '0 0 16px',
      color: 'inherit',
    },
    '& h2': { fontSize: 22 },
    '& h3': { fontSize: 20 },
    '& p': { margin: '0 0 16px' },
    '& ul': { margin: 0, paddingLeft: 20 },
    '& li': { marginBottom: 8 },
    '& a': { color: 'inherit' },
  },
  close: { position: 'absolute', right: 6, top: 6, zIndex: 1, color: '#000B33' },
  header: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    alignItems: 'start',
    gap: 32,
    padding: 32,
    '@media (max-width: 700px)': { gridTemplateColumns: 'minmax(0, 1fr)', padding: 24, gap: 24 },
  },
  illustration: {
    display: 'flex',
    height: 420,
    overflow: 'hidden',
    borderRadius: 12,
    backgroundColor: '#F2EEE8',
    '@media (max-width: 700px)': { height: 300 },
  },
  label: {
    flex: '0 0 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFFFF',
    '& span': {
      writingMode: 'vertical-rl',
      transform: 'rotate(180deg)',
      textTransform: 'uppercase',
      fontFamily: fonts.gothicSemiBold,
      fontSize: 16,
      letterSpacing: '0.12em',
      textAlign: 'center',
    },
  },
  image: { width: 'calc(100% - 40px)', height: '100%', objectFit: 'cover' },
  introduction: {
    minWidth: 0,
    paddingTop: 8,
    '& h3': { color: '#000B33', textTransform: 'uppercase', marginTop: 24 },
  },
  section: { padding: '0 32px 32px', '@media (max-width: 700px)': { padding: '0 24px 24px' } },
  panel: {
    padding: '48px 40px',
    color: '#FFFFFF',
    '& h2, & h3, & p, & li, & li::marker': { color: '#FFFFFF' },
    '@media (max-width: 700px)': { padding: '32px 24px' },
  },
  columns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 32,
    '@media (max-width: 700px)': { gridTemplateColumns: 'minmax(0, 1fr)', gap: 24 },
  },
  flowingText: {
    columnCount: 2,
    columnGap: 32,
    '@media (max-width: 700px)': { columnCount: 1 },
  },
  quote: {
    margin: '24px 0 0',
    textAlign: 'center',
    color: '#000B33',
    fontSize: 22,
    lineHeight: '30px',
    fontStyle: 'italic',
    '& svg': { display: 'block', margin: '0 auto 12px' },
    '& b': { fontSize: 16, fontStyle: 'normal', fontWeight: 600 },
  },
  accordions: { marginTop: 32, display: 'grid', gap: 24 },
  accordion: { paddingBottom: 20, borderBottom: '1px solid rgba(255,255,255,.35)', minWidth: 0 },
  toggle: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    width: '100%',
    padding: 0,
    border: 0,
    background: 'none',
    color: '#FFFFFF',
    fontFamily: fonts.opensans,
    fontSize: 15,
    fontWeight: 600,
    lineHeight: '20px',
    textAlign: 'left',
    cursor: 'pointer',
    '&:focus-visible': { outline: '2px solid white', outlineOffset: 4 },
    '& svg': { flexShrink: 0, marginLeft: 'auto' },
  },
  number: {
    flex: '0 0 24px',
    height: 24,
    borderRadius: '50%',
    background: '#FFFFFF',
    color: '#000A8D',
    textAlign: 'center',
    fontFamily: fonts.gothicSemiBold,
    fontSize: 13,
    lineHeight: '24px',
  },
  accordionBody: { padding: '12px 0 0 36px', fontSize: 13, lineHeight: '20px' },
  border: { border: '1px solid #FFFFFF', borderRadius: 12, padding: 24, marginTop: 24 },
  adImage: { display: 'block', maxWidth: '100%', maxHeight: 260, margin: '16px auto' },
}));
